import type { Message } from './useChatbotLogic';

/**
 * Shared rule for every interrupted-stream path (stop, new message mid-stream,
 * restore from storage): drop an empty in-progress bubble, keep a partial one.
 */
export function finalizeStreamingMessages(messages: Message[]): Message[] {
	return messages
		.filter((m) => !(m.sender === 'bot' && m.isTyping && !m.text.trim()))
		.map((m) =>
			m.sender === 'bot' && m.isTyping
				? { ...m, isTyping: false, fullContent: m.text }
				: m,
		);
}
